import { inject } from '@angular/core';
import {
  CanActivateFn,
  Route,
} from '@angular/router';
import { requireAuthentication } from '../../auth/auth-guard';
import { DashboardMainContentService } from '../../services/dashboard-main-content';
import { routes as settingsRoutes } from './settings/settings.routes';
import { routes as reportsRoutes } from './reports/reports.routes';
import { routes as utilitiesRoutes } from './utilities/utilities.routes';
import { routes as releasingRoutes } from './releasing/releasing.routes';
import { requireAnyPermission } from '../../auth/permission-guard';
import { PERMISSIONS } from '../../auth/permissions';

const use800pxCappedContentWidth: CanActivateFn = () => {
  inject(DashboardMainContentService).setMaxWidth('800px');
  return true;
};

export const routes: Route[] = [
  {
    path: '',
    canActivate: [requireAuthentication],
    canActivateChild: [
      requireAuthentication,
      requireAnyPermission([PERMISSIONS.BASIC, PERMISSIONS.ADMIN]),
    ],
    loadComponent: () => import('./dashboard').then(({ DashboardPage }) => DashboardPage),
    children: [
      ...settingsRoutes,
      ...reportsRoutes,
      ...utilitiesRoutes,
      ...releasingRoutes,
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/take-off',
      },
      {
        path: 'take-off',
        canActivate: [use800pxCappedContentWidth],
        loadComponent: () =>
          import('./take-off-list/take-off-list').then(({ TakeOffListPage }) => TakeOffListPage),
      },
      {
        path: 'take-off/:id',
        loadComponent: () => import('./take-off/take-off').then(({ TakeOffPage }) => TakeOffPage),
      },
    ],
  },
];
